import { AddPaymentMethod as AddPaymentMethodShared } from '../../../../components/Containers/ReviewCheckoutDrawer/PaymentMethod/AddPaymentMethod';
import { useFlow } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';
import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { PaymentType } from '../../types';

export const AddPaymentMethod = () => {
  const {
    billingAddress,
    newPaymentMethodUsingShippingAddress,
    paymentErrorCode,
    setBillingAddress,
    setNewPaymentMethodType,
    setNewPaymentMethodUsingShippingAddress,
    setPaymentErrorCode,
    setSelectedPaymentMethodId,
    setSelectedPaymentType,
    setUsingNewPaymentMethod,
    updateDrawEntryIntent,
  } = usePreAuthDrawCtx();

  const { goToStep } = useFlow();
  const [emitter] = useAnalyticsEmitter();

  return (
    <AddPaymentMethodShared
      billingAddress={billingAddress}
      error={paymentErrorCode ?? undefined}
      isBillingSameAsShipping={newPaymentMethodUsingShippingAddress}
      onPaymentElementChange={(event) => {
        setNewPaymentMethodType(event.value.type);
      }}
      onSave={() => {
        setSelectedPaymentType(PaymentType.CARD);
        emitter('new details', 'saved', {
          'billing same as shipping address':
            newPaymentMethodUsingShippingAddress,
        });
        setPaymentErrorCode(null);
        setSelectedPaymentMethodId(null);
        setUsingNewPaymentMethod(true);
        updateDrawEntryIntent();
        goToStep('apply');
      }}
      setBillingAddress={setBillingAddress}
      setIsBillingSameAsShipping={setNewPaymentMethodUsingShippingAddress}
    />
  );
};
